// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-content{text-align:left}.blog-content .g-breadcrumb{display:block;justify-content:flex-start}.blog-social .g-social-share{margin-top:2.5rem}.cms-button-v2{display:flex;justify-content:center;margin:1em}@media (min-width:768px){.blog-container{display:grid;grid-template-columns:1fr 42.1875rem 1fr}.blog-social .g-social-share{margin-top:0;position:sticky;top:5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
